import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RouterService } from '../../services';

@Directive()
export class HomeWaitingScreenPageBaseComponent implements OnInit {
  public type: string;

  constructor(
    private routerService: RouterService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.type = this.activeRoute.snapshot?.params?.type;
  }

  public goToHomeOverview() {
    this.routerService.back();
  }
}
